<template>
  <form-section id="other_regulations" :headline="$t('form.other_regulations.legend')">
    <append-list
      id="other_regulations_input"
      :label="$t('form.other_regulations.other_regulations_input.label')"
      :placeholder="$t('form.other_regulations.other_regulations_input.placeholder')"
      v-model="otherRegulations"
      :errorMessage="this.$t('form.shared.validation_error')"
      :addButtonLabel="this.$t('form.other_regulations.other_regulations_input.add_button_label')"
      :removeButtonLabel="this.$t('form.shared.remove_button_label')"
    />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection";
import AppendList from "@/shared/components/AppendList";
export default {
  components: {
    FormSection,
    AppendList
  },
  data() {
    return {
      otherRegulations: []
    };
  },
  watch: {
    otherRegulations: {
      handler() {
        this.$store.commit("updateOtherRegulations", this.otherRegulations);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/OtherRegulationsInput.vue